import React, { Component } from "react";
import {
  getAvailableLanguages,
  getCurrentLang,
  getCurrentLangFullName,
} from "../../assets/creator/translations";
import "./LanguageSelector.css";
import "../../containers/Sidebar/SidebarStyleMenu.css";
import releaseSettings from "../../config/releaseSettings";

class LanguageSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      currentLang: getCurrentLang(),
      langList: ["Polski", "English", "Deutsch", "Français"],
      currentLangFullName: getCurrentLangFullName(this.props.langList),
    };
  }

  toogleLanguageMenu = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  closeMenu = () => {
    this.setState({ isMenuOpen: false });
  };

  changeLanguage = (newLang) => {
    this.setState({ currentLang: newLang });

    if (newLang === "pl") {
      this.setState({ currentLangFullName: this.state.langList[0] });
    } else if (newLang === "en") {
      this.setState({ currentLangFullName: this.state.langList[1] });
    } else if (newLang === "de") {
      this.setState({ currentLangFullName: this.state.langList[2] });
    } else if (newLang === "fr") {
      this.setState({ currentLangFullName: this.state.langList[3] });
    } else {
      this.setState({ currentLangFullName: this.state.langList[0] });
    }

    this.props.langChangeHandler(newLang);
  };

  getClassModifier = (lang, currentLang) =>
    lang === currentLang ? "language--current" : "";

  render = () =>
    releaseSettings.hideLanguageSelector ? null : (
      <div className="lang-picker-wrapper" onMouseLeave={this.closeMenu}>
        <div className="style-menu__language-icon">
          <img
            className="language__flag--current"
            src={`./img/icons/flags/${this.state.currentLang}.png`}
            alt={this.state.currentLang}
          ></img>
          <button
            onClick={this.toogleLanguageMenu}
            className="style-menu__toogle-language-button"
          >
            {/* <p className='language__name-p'>{this.state.langList.map( language => ( language.slice()[0]===lang.slice()[0].toUpperCase() && language ))}</p> */}

            <p> {this.state.currentLangFullName} </p>
            <img
              src={!this.state.isMenuOpen ? arrowIconDown : arrowIconUp}
              alt=""
              className="language__toggle-icon"
            ></img>
          </button>
        </div>

        {this.state.isMenuOpen && (
          <div className="language-selector">
            <div className="language__selector-options language-selector-mobile">
              {getAvailableLanguages().map((lang) => (
                <div
                  key={lang}
                  className={`language ${this.getClassModifier(
                    lang,
                    this.state.currentLang
                  )}`}
                  onClick={() => {
                    this.changeLanguage(lang);
                    this.closeMenu();
                  }}
                >
                  <li className="language__name">
                    <img
                      className="language__flag"
                      src={`./img/icons/flags/${lang}.png`}
                      alt={lang}
                    ></img>
                    <p className="language__name-p">
                      {this.state.langList.map(
                        (language) =>
                          language.slice()[0] ===
                            lang.slice()[0].toUpperCase() && language
                      )}
                    </p>
                  </li>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
}

export default LanguageSelector;

const arrowIconDown = "../../../img/icons/arrows/keyboard-arrow-down.svg";
const arrowIconUp = "../../../img/icons/arrows/keyboard-arrow-up.svg";



// WEBPACK FOOTER //
// ./src/components/LanguageSelector/LanguageSelector.js